module.exports = __webpack_public_path__ + "static/media/henrique-feitosa.e1d90e5e.jpg";